import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentsSidebarListItemDialogContainer from './VeltCommentsSidebarListItemDialogContainer/VeltCommentsSidebarListItemDialogContainer';
import VeltCommentsSidebarListItemGroup from './VeltCommentsSidebarListItemGroup/VeltCommentsSidebarListItemGroup';
var VeltCommentsSidebarListItem = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-list-item-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarListItem.Group = VeltCommentsSidebarListItemGroup;
VeltCommentsSidebarListItem.DialogContainer = VeltCommentsSidebarListItemDialogContainer;
export default VeltCommentsSidebarListItem;
